<template>
  <button class="nav__toggler" @click="toggleMenu">
    <span></span>
    <span></span>
    <span></span>
  </button>
</template>

<script>
export default {
  name: 'BaseToggler',
  methods: {
    toggleMenu () {
      this.$emit('toggleMenu')
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// components/_UI/BaseToggler.vue